import VueBase from './VueBase';
import PageList from '@/models/Pagination/PageList';

export default abstract class ListPageBase extends VueBase {
  protected pageSize: number = 20;
  protected pageNumber: number = 1;
  protected addOrEdit: boolean = false;
  protected onLoading: boolean = false;
  protected pagedData: PageList<any> = {
    PageSize: 0,
    PageNumber: 0,
    Data: [],
    TotalItemCount: 0 
  };

  abstract updatePageData(): void;
  abstract get formTitle(): string;
  abstract loadData(): Promise<void> | void

  protected async loadInit(): Promise<void> {
    this.onLoading = true;
    await this.loadData();
    this.updatePageData();
    this.onLoading = false;
  }

  protected displayError(): void {
    this.showAlertDialog('The requested operation failed from an unknown issue. Please contact support if the error persists.', 'Validation Error', { isError: true });
    }

    protected displayErrorMessage(message: string): void {
        this.showAlertDialog(message, 'Validation Error', { isError: true });
    }
}